<div [class.disabled]="reprocessedFlag" class="my-2">
  @if (table2?.data; as tableData) {
    <app-reprocessing-multiple-input-filter [tableFilters]="tableData.tableFilters"
      (fetchData)="fetchData($event)" [calledFilter]="callFilter" (selectedFilter)="onSelectedFilter($event)">
    </app-reprocessing-multiple-input-filter>
  }
</div>
<mat-card>
  <div class="table-container mat-elevation-z6">
    @if (isLoadingResults) {
      <div class="loading-shade">
        @if (isLoadingResults) {
          <mat-spinner></mat-spinner>
        }
        <div class="hint">
          @if (isHint) {
            <p>
              <br> Reprocessing, Please wait...
                <span class="sub-hint">
                  <br>If another page is loaded while reprocessing, the results of any reprocessed work orders will not be
                    displayed.
                    <br> Reprocessing will continue.
                    </span>
                  </p>
                }
              </div>
            </div>
          }

          @if (loading) {
            <div class="loading-shade">
              @if (loading) {
                <mat-spinner></mat-spinner>
              }
            </div>
          }

          <!-- <----New Reprocessing table code ------>
           <div class="row">
            <br>
            <br>
            <div class="col-md-12" style="display: flex; align-items: center; flex-wrap: wrap;">
              <div class="col-md-8">
          <div class="container" style="padding: 0; margin: 0;">
            <mat-icon style="color: rgb(163 163 163);vertical-align: middle;">info</mat-icon>
            <span style="margin-left: 7px;">
              <u style="color: rgb(117 117 117); cursor: pointer;" (click)="openDialog()">Reprocessing Rules</u>
            </span>
          </div>
          </div>

          <div class="col-md-4">
          <div class="btn" style="display: flex; justify-content: flex-end; gap: 15px; width: 100%; padding: 0;">
            <button mat-flat-button color="primary" (click)="onReprocess()"
            [disabled]="selection.hasValue() == false || reprocessedFlag == true">Reprocess</button>
            <button (click)="onRefresh()" mat-flat-button color="primary"
            [disabled]=" reprocessedFlag == false">Refresh</button>
          </div> 
          </div>
          </div>
          </div>
          @if (reprocessedFlag == true) {
<p style="font-weight: bold; margin-top: -1%;
    float: right;
    font-size: small;
    color: red;">
              <br>Please click the Refresh button before continuing.
              </p>
            }

            <div [hidden]="hideReprocessedTable == true">
              <div>
                <!-- <-----Reprocessed table after Reprocessing----->
                <!-- // .....  static reprocessing table starts here..... afterReprocessing ....// -->
                <div>
                  @if (reprocessedFlag == true) {
                    <p
                      style="width: 22%; margin-left: 2%; font-weight: bold; color: rgb(53 74 85);">
                      <br> Results
                      </p>
                    }
                    <!-- <mat-paginator #checkedpaginator [hidden]="reprocessedFlag == false" [pageSizeOptions]="[100]"
                    aria-label="Select page of periodic elements" style="display: contents">
                  </mat-paginator> -->
                </div>



                @if (reprocessedFlag == true) {
                  <div class="table-scroll-container">
                    <table mat-table #table [dataSource]="checkedDataSource" class="mat-elevation-z8">
                      <ng-container matColumnDef="selected">
                        <th mat-header-cell *matHeaderCellDef style="color: rgba(0, 0, 0, .54);background-color: #ffffff;">
                          <mat-checkbox (change)="$event ? masterCheckedToggle() : null" [disabled]="true" [checked]="true">
                          </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let row">
                          <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? checkedSelection.toggle(row) : null"
                            [checked]="true" [disabled]="true">
                          </mat-checkbox>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="workOrderNumber">
                        <th mat-header-cell *matHeaderCellDef style="color: rgba(0, 0, 0, .54);background-color: #ffffff;"> # </th>
                        <td mat-cell *matCellDef="let element"> {{element.workOrderNumber}} </td>
                      </ng-container>
                      <ng-container matColumnDef="createdDate">
                        <th mat-header-cell *matHeaderCellDef style="color: rgba(0, 0, 0, .54);background-color: #ffffff;"> Date Received </th>
                        <td mat-cell *matCellDef="let element"> {{element.createdDate}} </td>
                      </ng-container>
                      <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef style="color: rgba(0, 0, 0, .54);background-color: #ffffff;"> Type </th>
                        <td mat-cell *matCellDef="let element"> {{element.type}} </td>
                      </ng-container>
                      <ng-container matColumnDef="storeId">
                        <th mat-header-cell *matHeaderCellDef style="color: rgba(0, 0, 0, .54);background-color: #ffffff;"> Store ID </th>
                        <td mat-cell *matCellDef="let element"> {{element.storeId}} </td>
                      </ng-container>
                      <ng-container matColumnDef="statusBeforeProcessing">
                        <th mat-header-cell *matHeaderCellDef style="color: rgba(0, 0, 0, .54);background-color: #ffffff;"> Status(Before Processing) </th>
                        <td mat-cell *matCellDef="let element"> {{element.statusBeforeProcessing}} </td>
                      </ng-container>
                      <ng-container matColumnDef="scheduledStart">
                        <th mat-header-cell *matHeaderCellDef style="color: rgba(0, 0, 0, .54);background-color: #ffffff;"> Scheduled Start </th>
                        <td mat-cell *matCellDef="let element"> {{element.scheduledStart}} </td>
                      </ng-container>
                      <ng-container matColumnDef="dueDate">
                        <th mat-header-cell *matHeaderCellDef style="color: rgba(0, 0, 0, .54);background-color: #ffffff;"> Due Date </th>
                        <td mat-cell *matCellDef="let element"> {{element.dueDate}} </td>
                      </ng-container>
                      <ng-container matColumnDef="reprocessed">
                        <th mat-header-cell *matHeaderCellDef style="color: rgba(0, 0, 0, .54);background-color: #ffffff;"> Reprocessed </th>
                        <td mat-cell *matCellDef="let element">
                          <!-- <span *ngIf="element.reprocessed == false">{{element.reprocessed}} </span> -->
                          @if (element.reprocessed == false) {
                            <button class="tick" mat-icon-button>
                              <mat-icon>close</mat-icon>
                            </button>
                          }
                          @if (element.reprocessed == true) {
                            <button class="tick" mat-icon-button>
                              <mat-icon>done</mat-icon>
                            </button>
                          }
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="reprocessedDate">
                        <th mat-header-cell *matHeaderCellDef style="color: rgba(0, 0, 0, .54);background-color: #ffffff;">Reprocessed Date</th>
                        <td mat-cell *matCellDef="let element"> {{element.reprocessedDate}} </td>
                      </ng-container>
                      <ng-container matColumnDef="statusAfterProcessing">
                        <th mat-header-cell *matHeaderCellDef style="color: rgba(0, 0, 0, .54);background-color: #ffffff;"> Status(After Processing) </th>
                        <td mat-cell *matCellDef="let element"> {{element.statusAfterProcessing}} </td>
                      </ng-container>
                      <ng-container matColumnDef="reprocessingCount">
                        <th mat-header-cell *matHeaderCellDef style="color: rgba(0, 0, 0, .54);background-color: #ffffff;"> Reprocessing Count </th>
                        <td mat-cell *matCellDef="let element"> {{element.reprocessingCount}} </td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="checkedSelection.toggle(row)"></tr>
                    </table>
                  </div>
                }

                <!-- <Static reprocessing table code ends here> -->

                <!-- <Dynamic reprocessing table code starts here> -->
                <!-- <mat-paginator #checkedpaginator *ngIf="reprocessedFlag == true"
                [pageSizeOptions]="[5,10]" aria-label="Select page of periodic elements">
              </mat-paginator>

              <table mat-table #table *ngIf="reprocessedFlag == true" [dataSource]="checkedDataSource.data.tableRows"
                class="mat-elevation-z8">
                <ng-container matColumnDef="isSelected">
                  <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="$event ? masterCheckedToggle() : null" [disabled]="true" [checked]="true">
                    </mat-checkbox>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? checkedSelection.toggle(row) : null"
                      [checked]="true" [disabled]="true">
                    </mat-checkbox>
                  </td>
                </ng-container>
                <ng-container matColumnDef="{{ column.columnDef }}"
                  *ngFor="let column of checkedDataSource.data.tableDefinitions  | slice: 1">
                  <th mat-header-cell *matHeaderCellDef [matTooltip]="column.columnTooltip"> {{column.header}} </th>
                  <td mat-cell *matCellDef="let element"> {{element[column.columnDef]}} </td>
                </ng-container>
                <ng-container matColumnDef="isReprocessed">
                  <th mat-header-cell *matHeaderCellDef> Reprocessed </th>
                  <td mat-cell *matCellDef="let element">
                    <button class="tick" *ngIf="element[reprocessed] == false" mat-icon-button>
                      <mat-icon>close</mat-icon>
                    </button>
                    <button class="tick" *ngIf="element[reprocessed] == true" mat-icon-button>
                      <mat-icon>done</mat-icon>
                    </button>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="tableDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: tableDisplayedColumns;"></tr>

              </table> -->

              <!-- <Dynamic reprocessing table code ends here> -->

            </div>

          </div>

          <!-- <-----Hold table before Reprocessing----->
          <!-- //Before reprocessing code starts here -->
          <div [hidden]="reprocessedFlag == true">
            <div class="row">
              <div class="col-md-12" style="display: flex; align-items: center; flex-wrap: wrap;">
                <div class="col-md-6">
                  @if (table2) {
                    <p style="margin-left: 2%;font-size: 1rem;font-weight: bold; color: rgb(53 74 85);">
                      <br> Work orders available to reprocess
                    </p>
                  }
                  <br>
                  <div>
                    @if (table2) {
                      <p style="margin-top: -25px;margin-left: 2%; font-size: 1rem;font-weight: bold; color: rgb(53 74 85);">Selected Row Count: {{this.selection.selected.length}}</p>
                    }
                  </div>
                </div>
                <div class="col-md-6" style="display: flex; justify-content: flex-end;">
                  <div>
                    <mat-paginator #paginator [pageSizeOptions]="[10, 25, 100]" class="mat-mdc-paginator classic-paginator" [length]="length" style="display: contents"
                      [disabled]="(length == 0)? true : false">
                    </mat-paginator>
                  </div>
                </div>
              </div>
            </div>

            
            </div>

            @if (table2 && reprocessedFlag == false) {
              <div class="table-scroll-container">
                <table mat-table #table [dataSource]="table3" class="mat-elevation-z8">
                  <ng-container matColumnDef="isSelected">
                    <th mat-header-cell *matHeaderCellDef style="color: rgba(0, 0, 0, .54);background-color: #ffffff;">
                      <mat-checkbox #ref (change)="$event ? masterToggle(ref) : null ;" [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()">
                      </mat-checkbox>
                      <!-- <mat-checkbox *ngIf="(reprocessedFlag == true && isRefresh == false)"
                      (change)="$event ? masterToggle() : null ;" [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()" [disabled]="true">
                    </mat-checkbox> -->
                  </th>
                  <td mat-cell *matCellDef="let row">
                    @if (((reprocessedFlag == false && isRefresh == false))) {
                      <mat-checkbox (click)="$event.stopPropagation()"
                        (change)="$event ? selection.toggle(row) : null ; isSomeSelected()" [checked]="selection.isSelected(row)">
                      </mat-checkbox>
                    }
                    <!-- <mat-checkbox *ngIf="(reprocessedFlag == true && isRefresh == false)" (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(row) : null ;" [checked]="selection.isSelected(row)" [disabled]="true">
                  </mat-checkbox> -->
                </td>
              </ng-container>
              @for (column of table2.data.tableDefinitions  | slice: 1; track column) {
                <ng-container matColumnDef="{{ column.columnDef }}">
                  <th mat-header-cell *matHeaderCellDef [matTooltip]="column.columnTooltip" style="color: rgba(0, 0, 0, .54);background-color: #ffffff;"> {{column.header}} </th>
                  <td mat-cell *matCellDef="let element"> {{element[column.columnDef]}} </td>
                </ng-container>
              }
              <tr mat-header-row *matHeaderRowDef="tableDisplayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: tableDisplayedColumns;"></tr>
            </table>
          </div>
        }

        <!-- <-----Hold table before Reprocessing----->
        <!-- //Before reprocessing code ends here -->

        <!-- <----New Reprocessing table code ------>



      </div>
    </mat-card>
